import React from 'react';

import TextField from './TextField';


/** Email input. (Domain autocomplete from the MUI version was disabled and was dropped.) */
const EmailField = React.forwardRef((props, ref) => {
  return (
    <TextField
      ref={ref}
      type="email"
      autoComplete="email username"
      {...props}
    />
  );
});

EmailField.displayName = 'EmailField';
export default EmailField;
